function OrderEditor() {}

OrderEditor.events = {
    isInit: true,

    init: function() {
        var funcs = OrderEditor.funcs;
        var that = this;

        if (that.isInit) {
            $("#right-pane-column").on('click', '.update-order-design', that.onShowSummary);
            $("#prolook-order-summary").on('click', ".update-order", that.onUpdateDesignOrder);

            that.isInit = false;
        }
    },

    onShowSummary: function() {
        var isReversible = _.isEqual(ub.config.isReversible, "1");
        var parentWindow = window.parent;

        if (isReversible) {
            parentWindow.Loader.orderItem.preview({stack: true});
            ReversibleOrderEditor.saveAndPreviewReversible();
        } else {
            Loader.orderItem.preview({stack: true});
            OrderEditor.funcs.prepareThumbnails();
        }
    },

    onUpdateDesignOrder: function() {
        var parentWindow = window.parent;
        var isReversible = _.isEqual(ub.config.isReversible, "1");
        
        if (isReversible) {
            parentWindow.ReversibleOrderEditor.updateReversibleDesignOrder();
        } else {
            OrderEditor.funcs.updateDesignOrder();
        }
    }
}

OrderEditor.funcs = {
    prepareThumbnails: function() {
        OrderEditor.funcs.prepareSizingBreakDown();
        SaveDesign.utilities.getPriceItemCode();
        SaveDesign.utilities.sortedModifierLabels();
        SaveDesign.utilities.setMaterialInfo();
        SaveDesign.funcs.prepareThumbnails();

        ub.front_view.visible = true;
        ub.back_view.visible = true;
        ub.left_view.visible = true;
        ub.right_view.visible = true;

        ub.funcs.deactivateMoveTool();

        ub.current_material.settings.thumbnails = {
            front_view: "",
            back_view: "",
            left_view: "",
            right_view: "",
        }

        if (typeof ub.data.previousThumbnails === "undefined") {
            ub.data.previousThumbnails = {
                front_view: "",
                back_view: "",
                left_view: "",
                right_view: "",
            }
        }

        this.uploadThumbnailUniformPreview("front_view")
        this.uploadThumbnailUniformPreview("back_view")
        this.uploadThumbnailUniformPreview("left_view")
        this.uploadThumbnailUniformPreview("right_view")
    },

    uploadThumbnailUniformPreview: function(view) {
        var _dataUrl = ub.getThumbnailImage(view);
        ub.data.previousThumbnails[view] = _dataUrl;

        $.ajaxSetup({
            headers: {
                'X-CSRF-TOKEN': $('meta[name="csrf-token"]').attr('content')
            }
        });

        // Loader 1 - 9
        Loader.loading(1, 9);

        $.ajax({
            data: JSON.stringify({ dataUrl: _dataUrl }),
            url: ub.config.host + "/saveLogo",
            dataType: "json",
            type: "POST",
            crossDomain: true,
            contentType: 'application/json',
            headers: {"accessToken": null},
            success: function (response){
                if(response.success) {
                    ub.current_material.settings.thumbnails[view] = response.filename;
                    $("#prolook-order-summary .order-design-preview ." + view + " img").attr('src', '');
                    $("#prolook-order-summary .order-design-preview ." + view + " img").attr('src', response.filename);
                    
                    if (ub.funcs.thumbnailsUploaded()) {
                        // Loader 2 - 9
                        Loader.loading(3, 9);
                        OrderEditor.funcs.onShowSummaryOfDesign();
                    }
                } else {
                    console.log('Error generating thumbnail for ' + view);
                    console.log(response.message);
                }
            },

            error: function(error) {
                console.log(error);
            }
        });
    },

    onShowSummaryOfDesign: function() {
        if (ub.config.design_type === "revised") {
            OrderEditor.funcs.generateNewPDF();
        } else {
            OrderEditor.funcs.prepareRevisedDesign();
        }
    },

    // Update Order Item 
    onUpdateOrderItem: function() {
        OrderEditor.funcs.postUpdateOrderItem(function(res) {
            if (res.success) {
                OrderEditor.funcs.onSuccessUpdatingDesignOrder();
            } else {
                OrderEditor.funcs.onErrorUpdatingOrderDesign();
            }
        }, function(err) {
            console.log(err)
            OrderEditor.funcs.onErrorUpdatingOrderDesign();
        });
    },

    postUpdateOrderItem: function(successHandler, errorHandler) {
        var _url = ub.config.api_host + '/api/order_item/update';
        var orderSetting = ub.config.order_data;
        var data = {
            "parent_order_item_id": ub.config.order_item,
            "order_id": ub.config.orderCode,
            "factory_order_id": null,
            "pid": null,
            "item_id": ub.current_material.material.item_id,
            "description": ub.current_material.material.name,
            "builder_customizations": JSON.stringify(ub.current_material.settings),
            "design_sheet": ub.current_material.settings.pdfOrderForm,
            "set_group_id": null,
            "status": "new",
            "shipped_date": "0000-00-00",
            "esd": "0000-00-00",
            "questions": null,
            "roster": JSON.stringify(orderSetting.roster),
            "attached_files": "[]",
            "additional_attachments": null,
            "notes": null,
            "brand": "prolook",
            "application_type": ub.config.uniform_application_type,
            "customizer_style_id": ub.current_material.material.id,
            "shipping": null,
            "line_item_id": ub.config.line_item_id
        };

        $.ajax({
            url: _url,
            dataType: "json",
            type: "POST",
            data: JSON.stringify(data),
            crossDomain: true,
            contentType: 'application/json',
            headers: {
                "accessToken": (ub.user !== false) ? atob(ub.user.headerValue) : null
            },
        
            success: successHandler,

            erorr: errorHandler
        });
    },

    // Create new Saved Design data and PDF file
    prepareRevisedDesign: function() {
        // Get saved design data
        var designPayload = SaveDesign.prepareSaveDesignPayload();
        SaveDesign.postSaveDesign(designPayload, function(response) {
            if (response.success) {
                // Loader 4 - 9
                Loader.loading(4, 9);
                ub.current_material.settings.savedDesignID = response.sd_id;
                OrderEditor.funcs.generateNewPDF();
            } else {
                OrderEditor.funcs.onErrorSavingDesign();
            }
        }, function(error) {
            OrderEditor.funcs.onErrorSavingDesign();
        })
    },

    updateDesignOrder: function() {
        UIkit.modal("#prolook-order-summary").hide();
        Loader.orderItem.updating();
        
        SaveDesign.updateSavedDesignBuilderCustomization(function(response) {
            if (response.success) {
                OrderEditor.funcs.onUpdateOrderItem();
            } else {
                console.log("ERROR WHILE UPDATING SAVED DESIGN");
                OrderEditor.funcs.onErrorSavingDesign();
            }
        }, function(error) {
            funcs.onErrorSavingDesign();
        })
    },

    // Create New PDF file
    generateNewPDF: function() {
        // Loader 7 - 9
        Loader.loading(7, 9);
        PdfPanel.pdfBuilder(function(response) {
            if (response.success) {
                OrderEditor.funcs.onSuccessPDF(response);
            } else {
                OrderEditor.funcs.onErrorPDF();
            }
        }, function(error) {
            OrderEditor.funcs.onErrorPDF();
        });
    },

    onSuccessPDF: function(response) {
        ub.current_material.settings.uniformPreviewPdf = response.pdfUrl;
        ub.current_material.settings.pdfOrderForm = response.pdfUrl;
        ub.data.rosterIsChange = false;

        $("#prolook-order-summary a.download-pdf-btn").attr("href", "");
        $("#prolook-order-summary a.download-pdf-btn").attr("href", response.pdfUrl);
        
        Loader.completeloading(function() {
            UIkit.modal("#prolook-order-summary").show();
        });
    },

    onErrorPDF: function() {
        // PDF Error Message
        var parentWindow = window.parent;
        var pdfErrorMessage = 'Something went wrong while generating the PDF. Please try again later. Send your feedback if the problem persists. We appreciate your comments. Our team will be working on it as soon as possible.';

        parentWindow.Loader.endloading(function() {
            parentWindow.ub.funcs.showNotification(pdfErrorMessage, "danger", 3000);
        });
    },

    onErrorSavingDesign: function() {
        var parentWindow = window.parent;
        var saveDesignError = 'Something went wrong while saving your design. Please try again later. Send your feedback if the problem persists. We appreciate your comments. Our team will be working on it as soon as possible.';
        parentWindow.Loader.endloading(function() {
            parentWindow.ub.funcs.showNotification(saveDesignError, "danger", 3000);
        });
    },

    onErrorUpdatingOrderDesign: function() {
        var parentWindow = window.parent;

        parentWindow.Loader.endloading(function() {
            parentWindow.ub.funcs.showNotification(
                "Something went wrong while updating your design order. Please try again later. Send your feedback if the problem persists. We appreciate your comments. Our team will be working on it as soon as possible.",
                "danger",
                3000
            );
        });
    },

    onSuccessUpdatingDesignOrder: function() {
        Loader.endloading(function() {
            ub.funcs.showNotification("Design successfully updated. Redirecting to order item page.", "success", 3000);

            // Add Confirmation Modal Here
            _.delay(function() {
                var redirect = ub.config.host + '/orders/' + ub.config.orderCode;
                
                if (typeof document.referrer !== "undefined") {
                    window.location.href = document.referrer;
                } else {
                    window.location.href = redirect;
                }
            }, 2000)
        });
    },

    prepareSizingBreakDown: function() {
        var _prepareSize = [];
        var _total = 0;
        var orderSetting = ub.config.order_data;

        _.each (orderSetting.roster, function (roster) {
            var rosterQty, rosterSize, rosterNumber;

            if (typeof roster.Quantity !== "undefined" && typeof roster.Size !== "undefined" && typeof roster.Number !== "undefined") {
                rosterQty = roster.Quantity;
                rosterSize = roster.Size;
                rosterNumber = roster.Number;
            } else {
                rosterQty = roster.quantity;
                rosterSize = roster.size;
                rosterNumber = roster.number;
            }

            _total += parseInt(rosterQty);

            var _obj = _.find(_prepareSize, {size: rosterSize});

            if (typeof _obj === "undefined") {
                _prepareSize.push({size: rosterSize, quantity: 0});
                _obj = _.find(_prepareSize, {size: rosterSize});
            }

            _obj.quantity +=  parseInt(rosterQty);
        });


        ub.current_material.settings.size_breakdown = _prepareSize;
    },

    showLoader: function() {
        $("#prolook-order-summary .save-design-loading").removeClass("uk-hidden");
        $("#prolook-order-summary .order-summary-main-container").addClass("uk-hidden");
    },

    hideLoader: function() {
        $("#prolook-order-summary .save-design-loading").addClass("uk-hidden");
        $("#prolook-order-summary .order-summary-main-container").removeClass("uk-hidden");
    }
}

OrderEditor.renderPreview = function(side1, side2, pdf) {
    var parentWindow = window.parent;
    var itemTemplate = parentWindow.document.getElementById("order-preview-reversible-template").innerHTML;
    var template = _.template(itemTemplate);

    parentWindow.$("#prolook-order-summary a.download-pdf-btn").attr("href", "");
    parentWindow.$("#prolook-order-summary a.download-pdf-btn").attr("href", pdf);

    parentWindow.$("#prolook-order-summary div.order-design-preview").html("");
    parentWindow.$("#prolook-order-summary div.order-design-preview").html(template({
        side1: side1,
        side2: side2
    }));

    
    parentWindow.Loader.completeloading(function() {
        parentWindow.UIkit.modal("#prolook-order-summary").show();
    });
}